import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import Clipboard from 'v-clipboard';

// for style imports please see index.scss

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Clipboard);
